/* tslint:disable */
import {
  CompanyAccount,
  ChartOfAccount,
  UserProfile
} from '../index';

declare var Object: any;
export interface LandlordPayoutInterface {
  "posting_date"?: Date;
  "amount"?: number;
  "ref_no"?: string;
  "memo"?: string;
  "from_chart_of_account_id": number;
  "to_chart_of_account_id": number;
  "id"?: number;
  "property_id"?: number;
  "land_lord_id"?: number;
  "createdAt": Date;
  "updatedAt": Date;
  "deletedAt"?: Date;
  Properties?: CompanyAccount;
  FromChartOfAccount?: ChartOfAccount;
  ToChartOfAccount?: ChartOfAccount;
  postingUser?: UserProfile;
}

export class LandlordPayout implements LandlordPayoutInterface {
  "posting_date": Date;
  "amount": number;
  "ref_no": string;
  "memo": string;
  "from_chart_of_account_id": number;
  "to_chart_of_account_id": number;
  "id": number;
  "property_id": number;
  "land_lord_id": number;
  "createdAt": Date;
  "updatedAt": Date;
  "deletedAt": Date;
  Properties: CompanyAccount;
  FromChartOfAccount: ChartOfAccount;
  ToChartOfAccount: ChartOfAccount;
  postingUser: UserProfile;
  constructor(data?: LandlordPayoutInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `LandlordPayout`.
   */
  public static getModelName() {
    return "LandlordPayout";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of LandlordPayout for dynamic purposes.
  **/
  public static factory(data: LandlordPayoutInterface): LandlordPayout{
    return new LandlordPayout(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'LandlordPayout',
      plural: 'LandlordPayouts',
      path: 'LandlordPayouts',
      idName: 'id',
      properties: {
        "posting_date": {
          name: 'posting_date',
          type: 'Date'
        },
        "amount": {
          name: 'amount',
          type: 'number'
        },
        "ref_no": {
          name: 'ref_no',
          type: 'string'
        },
        "memo": {
          name: 'memo',
          type: 'string'
        },
        "from_chart_of_account_id": {
          name: 'from_chart_of_account_id',
          type: 'number'
        },
        "to_chart_of_account_id": {
          name: 'to_chart_of_account_id',
          type: 'number'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
        "property_id": {
          name: 'property_id',
          type: 'number'
        },
        "land_lord_id": {
          name: 'land_lord_id',
          type: 'number'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
        "deletedAt": {
          name: 'deletedAt',
          type: 'Date',
          default: new Date(0)
        },
      },
      relations: {
        Properties: {
          name: 'Properties',
          type: 'CompanyAccount',
          model: 'CompanyAccount',
          relationType: 'belongsTo',
                  keyFrom: 'property_id',
          keyTo: 'id'
        },
        FromChartOfAccount: {
          name: 'FromChartOfAccount',
          type: 'ChartOfAccount',
          model: 'ChartOfAccount',
          relationType: 'belongsTo',
                  keyFrom: 'from_chart_of_account_id',
          keyTo: 'id'
        },
        ToChartOfAccount: {
          name: 'ToChartOfAccount',
          type: 'ChartOfAccount',
          model: 'ChartOfAccount',
          relationType: 'belongsTo',
                  keyFrom: 'to_chart_of_account_id',
          keyTo: 'id'
        },
        postingUser: {
          name: 'postingUser',
          type: 'UserProfile',
          model: 'UserProfile',
          relationType: 'belongsTo',
                  keyFrom: 'land_lord_id',
          keyTo: 'id'
        },
      }
    }
  }
}
